import { digObject } from '@domain-group/javascript-utils'

import {
  Box, DashboardModule, Form,
} from '@domain-group/suit-theme'

import { useAgencyForm } from '@hooks/useAgency'

import InfoToolTip from '@components/InfoToolTip'

import { AgencyModel } from '@models/types'

interface AgencyPaymentInformationProps {
  agency: AgencyModel,
  agencyFormPayload: ReturnType<typeof useAgencyForm>,
}

const AgencyPaymentInformation = (props: AgencyPaymentInformationProps) => {
  const { agencyFormPayload } = props
  const {
    entityState,
    entityState: {
      bank_account_bsb,
      bank_account_name,
      bank_account_number,
    },
    errors,
    handlers,
  } = agencyFormPayload

  const { payment_terms_unit, payment_terms_value } = digObject(entityState, 'options', {})

  return (
    <DashboardModule
      headerRight={(
        <InfoToolTip>
          Add your banking details and the information can be automatically filled in on your marketing quotes.
        </InfoToolTip>
      )}
      title="Agency Payment Information"
    >
      <Form padding="large">
        <Form.Row>
          <Form.Field label="Account Name">
            <input name="bank_account_name" type="text" value={bank_account_name} {...handlers} />
          </Form.Field>

          {/*
           // @ts-expect-error TS2322 */}
          <Form.Field label="Payment Terms" marginTop={['large', 0]} errorMessage={errors.payment_terms_value}>
            <Box>
              <input
                name="options.payment_terms_value"
                style={{ marginBottom: 0 }}
                type="number"
                value={payment_terms_value || 1}
                {...handlers}
              />

              <Box marginLeft="medium">
                {/*
                 // @ts-expect-error TS2322 */}
                <select name="options.payment_terms_unit" value={payment_terms_unit || 'months'} {...handlers}>
                  <option value="days">Days</option>
                  <option value="months">Months</option>
                </select>
              </Box>
            </Box>
          </Form.Field>
        </Form.Row>

        <Form.Row marginTop="large">
          <Form.Field label="Account BSB">
            <input name="bank_account_bsb" type="text" value={bank_account_bsb} {...handlers} />
          </Form.Field>

          {/*
           // @ts-expect-error TS2322 */}
          <Form.Field label="Account Number" marginTop={['large', 0]}>
            <input name="bank_account_number" type="text" value={bank_account_number} {...handlers} />
          </Form.Field>
        </Form.Row>
      </Form>
    </DashboardModule>
  )
}

export default AgencyPaymentInformation
